
import React, { useState } from 'react';
import { Grid, TextField, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, Button, FormGroup, FormLabel } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { putCacheTechnician, putTechnician } from '../API/technicianAPI';

function EditTechnician() {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const location = useLocation();
    const { technician } = location.state || {};

    const [technicianParameters, setTechnicianParameters] = useState({
        firstname: technician.firstname,
        lastname: technician.lastname,
        team: technician.team,
        rest_day: technician.rest_day
    })

    const handleTechnicianChange = (field, value) => {
        setTechnicianParameters(prev => ({
            ...prev,
            [field]: value
        }));
    }
    const options = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

    const handleChange = (event) => {
        const { value, checked } = event.target;
        handleTechnicianChange(
            "rest_day",
            checked
                ? [...technicianParameters.rest_day, value]
                : technicianParameters.rest_day.filter((item) => item !== value)
        );
    };


    async function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true); // Set loading to true

        try {
            // Update technician data
            await putTechnician(technician.id, technicianParameters);

            // Construct the name from technicianParameters
            const cacheTechnicianParameters = {
                name: `${technicianParameters.lastname}, ${technicianParameters.firstname}`,
            };

            // Update cache technician data
            await putCacheTechnician(technician.id, cacheTechnicianParameters);
        } catch (error) {
            console.error("Error occurred during submission:", error);
        } finally {
            setIsLoading(false); // Set loading to false
        }
    }


    return (
        <div>
            <h1 className="page-header">Edit Technician</h1>
            <form onSubmit={handleSubmit} className="job-order-form">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="team-label" sx={{ fontSize: '0.875rem' }}>
                                        Team
                                    </InputLabel>
                                    <Select
                                        labelId="team-label"
                                        name="type"
                                        value={technicianParameters.team}
                                        label="Team"
                                        sx={{ fontSize: '0.875rem' }}
                                        onChange={(e) => handleTechnicianChange('team', e.target.value)}
                                    >
                                        <MenuItem value="Delta">Delta</MenuItem>
                                        <MenuItem value="Sigma">Sigma</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <TextField
                                    name="firstname"
                                    label="Firstname"
                                    value={technicianParameters.firstname}
                                    fullWidth
                                    onChange={(e) => handleTechnicianChange('firstname', e.target.value)}
                                    InputProps={{ sx: { fontSize: '0.875rem' } }}
                                    InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={5}>
                                <TextField
                                    name="lastname"
                                    label="Lastname"
                                    value={technicianParameters.lastname}
                                    fullWidth
                                    onChange={(e) => handleTechnicianChange('lastname', e.target.value)}
                                    InputProps={{ sx: { fontSize: '0.875rem' } }}
                                    InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <FormGroup>
                                    <FormLabel component="legend">Rest Day</FormLabel>
                                    <Grid container spacing={2}>
                                        {options.map((option) => (
                                            <Grid item xs={3} key={option}> {/* Each item takes up half the width (2 per row) */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={technicianParameters.rest_day.includes(option)}
                                                            onChange={handleChange}
                                                            value={option}
                                                        />
                                                    }
                                                    label={option}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Form buttons */}
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" type="submit" sx={{ fontSize: '0.875rem' }}>
                            Submit
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => navigate('/manage-technicians')}
                            sx={{ marginLeft: '10px', fontSize: '0.875rem' }}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}

export default EditTechnician;
